export default {
    // 升舱查航班 by订单所属
    async getFlightListByOwnerTid(params) {
        let actiontype = 'getFlightListByOwnerTid'
        return await this.fetch(actiontype, params)
    },
    async getFlightListBySaleOrderTid(params) {
        let actiontype = 'getFlightBySaleOrderTid';
        return await this.fetch(actiontype, params);
    },
    // 升舱查航班 by证件号
    async getFlightByTicketNoOrFoid(params) {
        let actiontype = 'getFlightByTicketNoOrFoid'
        return await this.fetch(actiontype, params)
    },
    // 升舱创单
    async ticketUpGrade(params,type,timeout) {
        let actiontype = 'OrderService_TicketUpGradeHandler'
        return await this.fetch(actiontype, params, type, timeout)
    },
    // 升舱改期生单
    async submitUpgradeChangeDateOrder(params) {
        let actiontype = 'OrderService_TicketUpGradeReshceduleHandler';
        return await this.fetch(actiontype, params);
    },
    // 升舱退票
    async createUpgradeRefundOrder(params) {
        let actiontype = 'createUpgradeRefundOrder';
        return await this.fetch(actiontype, params);
    },
    // 升舱获取退票费用
    async getUpGradeRefundFees(params) {
        let actiontype = 'getUpGradeRefundFees';
        return await this.fetch(actiontype, params);
    },
    
}


// WEBPACK FOOTER //
// ./src/interfaces/modules/upgradeClass.js